import { ExerciseTODO, MaterialOptionProps, MaterialsItem, NotificationType, UserNotificationItem } from "@/types";


export function updateIsNewProperty(notifications: UserNotificationItem[], materialsList: MaterialsItem[]): MaterialsItem[] {
    
    const materials = materialsList?.filter(material => !material?.is_deleted).map(material => {
        const hasUnseenNotification = notifications?.some(notification =>
            (notification.action === NotificationType.ADD_MATERIALS) &&
            notification?.metadata?.some(meta => meta.id === material.id && !meta.seen)
        ) || false;
        return { ...material, isNew: hasUnseenNotification };
    });
    const sortedMaterials = materials.sort((a, b) => {
        if (a.isNew && !b.isNew) {
            return -1;
        } else if (!a.isNew && b.isNew) {
            return 1;
        } else {
            return 0;
        }
    })

    return sortedMaterials;
}

export function updateHasNewProperty(notifications: UserNotificationItem[], materials: MaterialsItem[], materialsOptions: MaterialOptionProps[]): MaterialOptionProps[] {
    const newMaterials = updateIsNewProperty(notifications, materials);
    const materialOptionsWithIsNew = materialsOptions?.map(materialO => {
        const hasUnseenNotification = newMaterials?.some(material =>
            (material?.lesson?.toLowerCase() === materialO?.path?.toLowerCase()) &&
            material?.isNew
        ) || false;
        return { ...materialO, hasNew: hasUnseenNotification };
    });    

    return materialOptionsWithIsNew;
}

//
export function updateExercisesIsNewProperty(notifications: UserNotificationItem[], exercisesTodo: ExerciseTODO[]): ExerciseTODO[] {
    const exercises = exercisesTodo?.map(material => {
        const hasUnseenNotification = notifications?.some(notification =>
            (notification.action === NotificationType.ADD_EXERCISES) &&
            notification?.metadata?.some(meta => meta.id === material.id && !meta.seen)
        ) || false;
        return { ...material, isNew: hasUnseenNotification };
    });
    const sortedExercises = exercises.sort((a, b) => {
        if (a.isNew && !b.isNew) {
            return -1;
        } else if (!a.isNew && b.isNew) {
            return 1;
        } else {
            return 0;
        }
    })

    return sortedExercises;
}

// filter notifications and return true or false if there are unseen ADD_EXERCISES
export function filterNotificationsExercises(notifications: UserNotificationItem[]): boolean {
    if (notifications?.length === 0) return false;
    return notifications?.some(notification => {
        return notification.action === NotificationType.ADD_EXERCISES &&
            notification?.metadata?.some(meta => !meta.seen)
    });
}


// filter notifications and return true or false if there are unseen ADD_MATERIALS
export function filterNotificationsMaterials(notifications: UserNotificationItem[]): boolean {
    if(notifications?.length === 0) return false;
    return notifications?.some(notification => notification.action === NotificationType.ADD_MATERIALS &&
        notification?.metadata?.some(meta => !meta.seen));
}

// filter notifications and return true or false if there are unseen ADD_EVENTS
export function filterNotificationsEvents(notifications: UserNotificationItem[]): boolean {
    if(notifications?.length === 0) return false;
    return notifications?.some(notification => notification.action === NotificationType.ADD_EVENTS &&
        notification?.metadata?.some(meta => !meta.seen));
}

// filter notifications and return those notifications that some of the metadata items are unseen 
export function filterNotificationsUnseen(notifications: UserNotificationItem[]): UserNotificationItem[] {
    if(notifications?.length === 0) return [];
    return notifications?.filter(notification => {
        if(notification?.metadata?.length) {
            return notification?.metadata?.some(meta => !meta.seen);
        }

        return !notification?.seen;
    });
}

// filter notifications and return true or false if there are notifications that are unseen
export function filterUnseenNotificationsEvents(notifications: UserNotificationItem[]): boolean {
    if(notifications?.length === 0) return false;
    return notifications?.some(notification => !notification?.seen);
}

// filter notifications and return true or false if there are notifications that all the metadata items are unseen
export function filterUnseenNotifications(notifications: UserNotificationItem[]): boolean {
    if(notifications?.length === 0) return false;
    return notifications?.some(notification => {
        if(notification?.metadata?.length === 0) return false;
        return !notification?.metadata?.every(meta => meta.seen);
    });
}